import { Image } from "./image";
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useScrollReveal } from "../hooks/useScrollReveal";

export const Magazine = (props) => {
  const [titleRef, titleVisible] = useScrollReveal();
  const [contentRef, contentVisible] = useScrollReveal();

  // const customStyles = `
  //     #magazine .Magazine-item {
  //       flex: 10%;
  //       box-sizing: border-box;
  //     }
  //     @media (max-width: 768px) {
  //       #magazine .Magazine-item {
  //         flex-basis: 25%;
  //       }
  //     }
  //     @media (max-width: 576px) {
  //       #magazine .Magazine-item {
  //         flex-basis: 33.33%;
  //       }
  //     }
  //     @media (max-width: 400px) {
  //       #magazine .Magazine-item {
  //         flex-basis: 100%;
  //       }
  //     }
  //     `
  return (
    <div id="magazine" className="text-center">
      <Helmet>
        <meta
          name="description"
          content="At Somarasa, we revive and celebrate cultural heritage, blending ancient traditions with the modern world. Explore how we transform the wisdom of our ancestors into a living, breathing part of today's experience."
        />
        <meta
          name="keywords"
          content="Somarasa, cultural heritage, global traditions, ancient wisdom, tradition transformation, cultural revival"
        />
        <meta
          property="og:description"
          content="Discover Somarasa, where we blend ancient traditions with modern life, preserving and celebrating cultural heritage worldwide."
        />
        <meta
          property="og:image"
          content="./somarasa full logo red background.webp"
        />
        <meta property="og:url" content="https://somarasa.co.in/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:description"
          content="Explore Somarasa's mission to blend ancient traditions with the modern world, reviving cultural heritage."
        />
        <meta
          name="twitter:image"
          content="./somarasa full logo red background.webp"
        />
      </Helmet>

      {/* <style>{customStyles}</style> */}
      <div id="aboutUs" className="container">
        <div
          ref={titleRef}
          className={`section-title reveal reveal--up ${titleVisible ? "is-visible" : ""}`}
        >
          <h2>What is Somarasa? </h2>
        </div>
        <div className="about-us">
          <div
            ref={contentRef}
            className={`styled-paragraph reveal-children ${contentVisible ? "is-visible" : ""
              }`}
          >
            <p style={{ padding: "0" }}>
              At Somarasa, we believe in the power of tradition to transform.
              We are a global movement, breathing new life into the cultural
              heritage of communities worldwide. Our mission is to take the
              timeless wisdom of our ancestors and weave it into the fabric of
              today’s world, creating a seamless blend of the old and the new.
            </p>
            <p>
              In a world that often forgets its roots, Somarasa is a guardian
              of tradition. We are here to reignite the practices, stories,
              and crafts that have been lost to time, transforming them into
              something that resonates with the present while honoring the
              past.
            </p>
            <p>
              Somarasa is not just about preserving memories; it’s about
              making them a living, breathing part of your experience.
              Together, we can ensure that the traditions that connect us all
              are not just remembered, but actively embraced and celebrated
              across the world.
            </p>
          </div>
        </div>
      </div>
    </div>


  );
};




